"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardGalleryItem } from "./WaveLeaderboardGalleryItem";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
interface WaveLeaderboardGalleryProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly curatedByGroupId?: string | undefined;
  readonly minPrice?: number | undefined;
  readonly maxPrice?: number | undefined;
  readonly priceCurrency?: string | undefined;
}
export const WaveLeaderboardGallery: React.FC<WaveLeaderboardGalleryProps> = t0 => {
  const $ = _c(31);
  const {
    wave,
    sort,
    onDropClick,
    curatedByGroupId,
    minPrice,
    maxPrice,
    priceCurrency
  } = t0;
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== maxPrice || $[2] !== minPrice || $[3] !== priceCurrency || $[4] !== sort || $[5] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId,
      minPrice,
      maxPrice,
      priceCurrency
    };
    $[0] = curatedByGroupId;
    $[1] = maxPrice;
    $[2] = minPrice;
    $[3] = priceCurrency;
    $[4] = sort;
    $[5] = wave.id;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  const [animationKey, setAnimationKey] = React.useState(0);
  const [previousSort, setPreviousSort] = React.useState(sort);
  let t2;
  let t3;
  if ($[7] !== previousSort || $[8] !== sort) {
    t2 = () => {
      if (previousSort !== sort) {
        setPreviousSort(sort);
        setAnimationKey(_temp);
      }
    };
    t3 = [sort, previousSort];
    $[7] = previousSort;
    $[8] = sort;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[11] !== drops) {
    t4 = drops.filter(_temp2) || [];
    $[11] = drops;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const dropsWithMedia = t4;
  if (isFetching && dropsWithMedia.length === 0) {
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center"><div className="tw-text-sm tw-text-iron-500">Loading drops...</div></div>;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  if (dropsWithMedia.length === 0) {
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center tw-text-sm tw-text-iron-500">No drops to show</div>;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t5;
  if ($[15] !== animationKey || $[16] !== dropsWithMedia || $[17] !== onDropClick || $[18] !== sort) {
    let t6;
    if ($[20] !== animationKey || $[21] !== onDropClick || $[22] !== sort) {
      t6 = drop_0 => <WaveLeaderboardGalleryItem key={drop_0.id} drop={drop_0} onDropClick={onDropClick} activeSort={sort} animationKey={animationKey} />;
      $[20] = animationKey;
      $[21] = onDropClick;
      $[22] = sort;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t5 = dropsWithMedia.map(t6);
    $[15] = animationKey;
    $[16] = dropsWithMedia;
    $[17] = onDropClick;
    $[18] = sort;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[24] !== fetchNextPage || $[25] !== hasNextPage || $[26] !== isFetchingNextPage) {
    t6 = hasNextPage && <div className="tw-col-span-full tw-mb-2 tw-mt-4 tw-flex tw-justify-center"><button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900 tw-px-4 tw-py-2 tw-text-sm tw-text-iron-400 tw-transition desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{isFetchingNextPage ? "Loading more..." : "Load more drops"}</button></div>;
    $[24] = fetchNextPage;
    $[25] = hasNextPage;
    $[26] = isFetchingNextPage;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== t5 || $[29] !== t6) {
    t7 = <div className="tw-@container"><div className="tw-grid tw-gap-x-4 tw-gap-y-8 @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3">{t5}{t6}</div></div>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
};
function _temp(prev) {
  return prev + 1;
}
function _temp2(drop) {
  return (drop.parts[0]?.media.length ?? 0) > 0;
}